import Vue from 'vue'
import Router from 'vue-router'
import Layout from "../views/Layout.vue"
import multiLevelMenu from '../views/multiLevelMenu.vue'

import Login from "@/views/Login.vue";
import findPassword from "@/views/findPassword.vue";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from "../store/index"
Vue.use(Router)
export const routes = [
  {
    path: '/Login',
    name: 'Login',
    meta: {title: '登录'},
    hidden: true,
    component: Login
  },

  {
    path: "/findPassword",
    name: "findPassword",
    hidden: true,
    meta: {title: '忘记密码'},
    component: findPassword
  },

  {
    path: "/showPDf",
    name: "showPDf",
    meta: {title: '显示PDF'},
    component: () => import("@/views/WebPdfShow.vue")
  },

  // {
  //   path: '',
  //   name: 'Layout',
  //   component: Layout,
  //   meta: {
  //     title: '首页',
  //   },
  //   redirect: './limitModel/LimitationSubModel',
  // },
  {
    path: "/register",
    name: 'register',
    component: Layout,
    meta: {title: '教师资格认定'},
    children: [
      {
        path: "ProvinceBatchPostponeSubModel",
        name: "ProvinceBatchPostponeSubModel",
        props:true,
        meta: {title: '变更记录'},
        component: () => import("@/views/kernalModel/ProvinceBatchPostponeSubModel/index.vue")
      },

    ]
  },


  {
    path: "/basic",
    name: 'basic',
    component: Layout,
    meta: {title: '基础信息'},
    children: [
      // {
      //   path: "ProvinceBatchPostponeSubModel",
      //   name: "ProvinceBatchPostponeSubModel",
      //   meta: {title: '变更记录'},
      //   component: () => import("@/views/kernalModel/ProvinceBatchPostponeSubModel/index.vue")
      // },

      {
        path: "siteOrgLogIndex",
        name: "siteOrgLogIndex",
        meta: {title: '机构公示信息痕迹'},
        component: () => import("@/views/basicModel/SiteOrgSubModel/siteOrgLogIndex.vue")
      },

    ]
  },
  {
    path: "/",
    name: "HomeWorks",
    meta: {title: '工作台'},
    component: Layout,
    children: [
      {
        path: "HomeWorks",
        name: "HomeWorks",
        meta: {title: '工作台',affix: true},
        component: () => import("@/views/HomeWorks/indexWorks.vue")
      },
      {
        path: "/eduDocModel",
        name:'eduDocModel',
        meta:{title:'资料下载'},
        component: () => import("@/views/basicModel/EduDocSubModel/index.vue")
      },
      {
        path: "Development",
        name: "Development",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "confirmaIndex",
        name: "confirmaIndex",
        meta: {title: '确认点'},
        component: () => import("@/views/HomeWorks/confirmaIndex.vue")
      }
    ]
  },

  {
    path: '/redirect',
    component: Layout,
    meta: {title: '跳转'},
    hidden:true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component:() => import("@/views/redirect/index.vue")
      }
    ]
  },

  //工作台
  {
    path: "/MyWorks",
    name: "MyWorks",
    meta: {title: '工作台'},
    component: Layout,
    children: [
      {
        path: "WfWorkflowAuditSubModel",
        name: "WfWorkflowAuditSub",
        meta: {title: '审批管理'},
        component: () => import("@/views/MyWorks/WfWorkflowAuditSubModel/index.vue")
      }
    ]

  },



  // 注册的 ===变更
  {
    path: "/enrollModel",
    name: 'enrollModel',
    component: Layout,
    meta: {title: '定期注册'},
    children: [
      {
        path: "ProvinceBatchPostponeSubModelS",
        name: "ProvinceBatchPostponeSubModelS",
        meta: {title: '变更记录'},
        component: () => import("@/views/enrollModel/ProvinceBatchPostponeSubModelS/index.vue")
      },

    ]
  },
  //  认定的变更
  {
    path: "/register",
    name:'register',
    component: Layout,
    meta:{title:'认定管理'},
    children:[
      {
        path: "ProvinceBatchPostponeSubModelRegister",
        name: "ProvinceBatchPostponeSubModelRegister",
        meta: {title: '变更记录'},
        component: () => import("@/views/enrollModel/ProvinceBatchPostponeSubModelS/index.vue")
      },

    ]
  },
  {
    path: "/historyDataManage",
    name:'historyDataManage',
    component: Layout,
    meta:{title:'证书信息管理'},
    children:[
      {
        path: "hisProvinceBatchPostponeSubModel",
        name: "hisProvinceBatchPostponeSubModel",
        meta: {title: '变更记录'},
        component: () => import("@/views/enrollModel/ProvinceBatchPostponeSubModelS/index.vue")
      },

    ]
  },
  {
    path: "/ecertModel",
    name:'ecertModel',
    component: Layout,
    meta:{title:'电子证照管理'},
    children:[
      {
        path: "ecertOrgStamp",
        name: "ecertOrgStamp",
        meta: {title: '机构电子印章管理'},
        component: () => import("@/views/ecertModel/EcertOrgStampSubModel/index.vue")
      },

    ]
  },
  {
    path: "/basicModel",
    name:'basicModel',
    component: Layout,
    meta:{title:'基础信息管理'},
    children:[
      {
        path: "BasicsProvinceBatchPostponeSubModel",
        name: "BasicsProvinceBatchPostponeSubModel",
        meta: {title: '变更记录'},
        component: () => import("@/views/enrollModel/ProvinceBatchPostponeSubModelS/index.vue")
      },

    ]
  },

  {
    path: "/limitModel",
    name: "limitModelMenu",
    component: Layout,
    meta: {title: '限制库管理'},
    children: [

      {
        path: "LimitationInfoSubModel",
        name: "LimitationInfoSubModel",
        meta: {title: '限制库管理'},
        component: () => import("@/views/limitModel/LimitationInfoSubModel/index.vue")
      },
      {
        path: "LimitationInfoFuHeSubModel",
        name:"LimitationInfoFuHeSubModel",
        meta:{title:'限制库审批'},
        component: () => import("@/views/limitModel/LimitationInfoFuHeSubModel/index.vue")
      },

      {
        path: "AllRestrictedLibraryData",
        name: "AllRestrictedLibraryData",
        meta: {title: '查询全国限制库数据'},
        component: () => import("@/views/limitModel/LimitationInfoSubModelAll/index.vue")
      },

      {
        path: "LimitationInfoSubOtherModel",
        name:"LimitationInfoSubOtherModel",
        meta:{title:'其他机构限制库查询',requireAuth: true},
        component: () => import("@/views/limitModel/LimitationInfoSubOtherModel/index.vue")
      },
      {
        path: "LimitationSubModel",
        name: "LimitationSubModel",
        meta: {title: '限制库发布初审'},
        component: () => import("@/views/limitModel/LimitationSubModel/index.vue")
      },
      {
        path: "WfWorkflowAuditSubModel",
        name:"WfWorkflowAuditSubModel",
        meta:{title:'限制库发布审批'},
        component: () => import("@/views/limitModel/WfWorkflowAuditSubModel/index.vue")
      },
      {
        path: "PushRecordQuery",
        name:"PushRecordQuery",
        meta:{title:'限制库推送记录查询'},
        component: () => import("@/views/limitModel/LimitationInfoSubPushRecordQuery/index.vue")
      },
      // {
      //   path: "WfWorkflowMainSubModel",
      //   name:"WfWorkflowMainSubModel",
      //   meta:{title:'流程主表管理'},
      //   component: () => import("@/views/limitModel/WfWorkflowMainSubModel/index.vue")
      // },
      // {
      //   path: "WfWorkflowNodeSubModel",
      //   name:"WfWorkflowNodeSubModel",
      //   meta:{title:'流程节点管理'},
      //   component: () => import("@/views/limitModel/WfWorkflowNodeSubModel/index.vue")
      // }
    ]
  },
]
export const asyncRouterMap =[
  {
    path: "/website",
    name: 'website',
    component: Layout,
    meta: {title: '网站管理'},
  },
  {
    path: "/tqcStat",
    name: 'tqcStat',
    component: Layout,
    meta: {title: '大屏监测'},
  },


  {
    path: "/auditorExamptionConfirm",
    name: 'normal',
    component: Layout,
    meta: {title: '免试认定数据报送'},
    children: [

      {
        path:"filingsManage",
        name:"filings",
        meta: { title:"备案管理" },
        component: multiLevelMenu,
        children:[
          {
            path: "normaleUniversity",
            name: "normaleUniversity",
            meta:{ title:"免试认定高校备案" },
            component: () => import("@/views/auditorExamptionConfirm/filingsManage/normaleUniversity/index.vue")
          },
          {

            path: "schoolnormaleUniversity",
            name: "schoolnormaleUniversity",
            meta: {title: '查看学校备案信息'},
            component: () => import("@/views/auditorExamptionConfirm/schoolnormaleUniversity/index.vue")
          },
          {
            path: "normaleProvinceLeader",
            name: "normaleProvinceLeader",
            meta:{ title:"改革工作组备案" },
            component: () => import("@/views/auditorExamptionConfirm/filingsManage/normaleProvinceLeader/index.vue")
          },
          {
            path: "normalEduAbilityAssess",
            name: "normalEduAbilityAssess",
            meta:{ title:"教育教学能力考核办法备案" },
            component: () => import("@/views/auditorExamptionConfirm/filingsManage/normalEduAbilityAssess/index.vue")
          },
          {
            path: "normaleUniversityRoster",
            name: "normaleUniversityRoster",
            meta:{ title:"免试高校及专业名单管理" },
            component: () => import("@/views/auditorExamptionConfirm/filingsManage/normaleUniversityRoster/index.vue")
          },
        ]
      },


      {
        path:"reviewTime",
        name:"reviewTime",
        meta: { title:"数据报送及审核时间管理" },
        component: multiLevelMenu,
        children:[
          {
            path: "NormalBatch",
            name: "NormalBatch",
            meta:{ title:"报送批次设置"},
            component: () => import("@/views/auditorExamptionConfirm/reviewTime/normalBatch/index.vue")
          },
          {
            path: "normalUploadTimeSet",
            name: "normalUploadTimeSet",
            meta:{ title:"报送及审核时间设置"},
            component: () => import("@/views/auditorExamptionConfirm/reviewTime/normalUploadTimeSet/index.vue")
          },
          {
            path: "zgzxdeskTop",
            name: "zgzxdeskTop",
            meta:{ title:"报送及审核时间查看"},
            component: () => import("@/views/auditorExamptionConfirm/reviewTime/zgzxdeskTop/index.vue")
          },

        ]
      },
      {
        path: "zgzxdeskTop2",
        name: "zgzxdeskTop2",
        meta:{ title:"数据报送及审核时间查看"},
        component: () => import("@/views/auditorExamptionConfirm/zgzxdeskTop2/index.vue")
      },

      {
        path: "normalSmsSend",
        name: "normalSmsSend",
        meta: {title: '短信发送管理'},
        component: () => import("@/views/auditorExamptionConfirm/normalSmsSend/index.vue")
      },


      // {
      //   path: "normalSmsSend",
      //   name: "normalSmsSend",
      //   meta: {title: '短信发送管理'},
      //   component: () => import("@/views/auditorExamptionConfirm/normalSmsSend/index.vue")
      // },

      {
        path: "UserNormal",
        name: "UserNormal",
        meta: {title: '高校用户管理'},
        component: () => import("@/views/basicModel/UserNormal/index.vue")
      },




      {
        path: "schoolnormalEduAbilityAssess",
        name: "normalEduAbilityAssess2",
        meta: {title: '教育教学能力考核办法备案'},
        component: () => import("@/views/auditorExamptionConfirm/schoolnormalEduAbilityAssess/index.vue")
      },


      {
        path:"normalData",
        name:"normalData",
        meta: { title:"数据报送及审核时间管理" },
        component: multiLevelMenu,
        children:[
          {
            path: "normalPreServiceSysTeacher",
            name: "normalPreServiceSysTeacher",
            meta:{ title:"数据采集与审核"},
            component: () => import("@/views/auditorExamptionConfirm/normalData/normalPreServiceSysTeacher/index.vue")
          },
          {
            path: "normalTeacherImportLog",
            name: "normalTeacherImportLog",
            meta:{ title:"数据导入记录查询"},
            component: () => import("@/views/auditorExamptionConfirm/normalData/normalTeacherImportLog/index.vue")
          },
          {
            path: "normalTeacherAllWorkList",
            name: "normalTeacherAllWorkList",
            meta:{ title:"数据报送统计"},
            component: () => import("@/views/auditorExamptionConfirm/normalData/normalTeacherAllWorkList/index.vue")
          },
          {
            path: "schooljylnormalPreServiceTeacher",
            name: "normalPreServiceTeacher2",
            meta:{ title:"教育类研究生数据管理"},
            component: () => import("@/views/auditorExamptionConfirm/normalData/schooljylnormalPreServiceTeacher/index.vue")
          },
          {
            path: "schoolgfnormalPreServiceTeacher",
            name: "normalPreServiceTeacher3",
            meta:{ title:"师范生数据管理"},
            component: () => import("@/views/auditorExamptionConfirm/normalData/schoolgfnormalPreServiceTeacher/index.vue")
          },
        ]
      },
      {
        path: "normalSubjectRuleFile",
        name: "normalSubjectRuleFile",
        meta: {title: '科目三比对数据'},
        component: () => import("@/views/auditorExamptionConfirm/normalSubjectRuleFile/index.vue")
      },



    ]

  },




  {
    path: "/basicModel",
    name: 'basicModel',
    component: Layout,
    meta: {title: '基础数据'},
    children: [
      {
        path: "BaseDictSubModel",
        name: "BaseDictSubModel",
        meta: {title: '字典管理'},
        component: () => import("@/views/basicModel/BaseDictSubModel/index.vue")
      },
      // {
      //   path: "MessageManageSubModel",
      //   name: "UserSubModel",
      //   meta: {title: '系统消息管理'},
      //   component: () => import("@/views/basicModel/MessageManageSubModel/index.vue")
      // },
      {
        path: "BaseSubjectSubModel",
        name:"BaseSubjectSubModel",
        meta:{title:'任教学科管理'},
        component: () => import("@/views/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType/index.vue"),
        children:[
          {
            path:"BaseSubjectSubModelType",
            name:"BaseSubjectSubModelType",
            meta:{title:'任教学科'},
            component: () => import("@/views/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType/index.vue"),
          },
          // {
          //   path:"BaseSubjectSubModelprimary",
          //   name:"BaseSubjectSubModelprimary",
          //   meta:{title:'任教学科'},
          //   component: () => import("@/views/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType/index.vue"),
          // },

        ]
      },
      {
        path:"InstitutionalUsers",
        name:"InstitutionalUsers",
        meta: { title:"机构和用户管理" },
        component: multiLevelMenu,
        children:[
          {
            path: "BaseOrgSubModel",
            name: "BaseOrgSubModel",
            meta:{ title:"机构管理" },
            component: () => import("@/views/basicModel/InstitutionalUsers/BaseOrgSubModel/index.vue")
          },
          {
            path: "BaseOrgHisoryLogSubModel",
            name: "BaseOrgHisoryLogSubModel",
            meta:{title:"机构管理日志"},
            component: () => import("@/views/basicModel/InstitutionalUsers/BaseOrgHisoryLogSubModel/index.vue")
          },
          {
            path:"employeeListManage",
            name:"userManageList",
            meta:{title:'用户管理'},
            component: () => import("@/views/basicModel/InstitutionalUsers/employeeListManage/employeeListManage"),
          },
          {
            path:"BaseOrgCreditSubModel",
            name:"RecognizedCredit",
            meta:{title:'认定机构统一社会信用代码管理'},
            component: () => import("@/views/basicModel/InstitutionalUsers/BaseOrgCreditSubModel/index.vue"),
          },
          // {
          //   path:"Development",
          //   name:"RegisteredCredit",
          //   meta:{title:'定期注册机构统一社会信用代码管理'},
          //   component: () => import("@/components/Development.vue"),
          // },
          {
            path:"roleListManage",
            name:"roleListManager",
            meta:{title:'角色权限管理'},
            component: () => import("@/views/basicModel/InstitutionalUsers/roleListManage/roleListManage"),
          },
          {
            path: "RmsUsbKeySubModel",
            name: "RmsUsbKeySubModelManage",
            meta: {title: 'USBKEY管理'},
            component: () => import("@/views/basicModel/InstitutionalUsers/RmsUsbKeySubModel/index.vue")
          },
          {
            path: "RmsUsbKeySubUserModel",
            name: "RmsUsbKeySubUserModelManage",
            meta: {title: '用户USBKEY管理'},
            component: () => import("@/views/basicModel/InstitutionalUsers/RmsUsbKeySubUserModel/index.vue")
          },
        ]
      },


      // {
      //   path: "BaseRareWordsSubModel",
      //   name:"BaseRareWordsSubModel",
      //   meta:{title:'生僻字信息表管理'},
      //   component: () => import("@/views/basicModel/BaseRareWordsSubModel/index.vue")
      // },

      // {
      //   path: "BaseCollegeTagSubModel",
      //   name:"BaseCollegeTagSubModel",
      //   meta:{title:'高校标签关联表管理'},
      //   component: () => import("@/views/basicModel/BaseCollegeTagSubModel/index.vue")
      // },




      {
        path: "EnrollSiteOrgSubModel",
        name: "RegisterMyOrgSubModel",
        meta: {title: '定期注册机构公示信息管理'},
        component: () => import("@/views/basicModel/SiteOrgSubModel/enrollIndex.vue")
      },

      {
        path: "SiteOrgSubModel",
        name: "MyOrgSubModel",
        meta: {title: '认定机构公示信息管理'},
        component: () => import("@/views/basicModel/SiteOrgSubModel/index.vue")
      },

      {
        path: "SysMsg",
        name: "SysMsg",
        meta: {title: '消息管理'},
        component: () => import("@/views/basicModel/SysMsgModel/index.vue")
      },


      {
        path: "ConfirmationPointQuery",
        name: "ConfirmationPointQuery",
        meta: {title: '查询认定确认点用户'},
        component: () => import("@/views/basicModel/ConfirmationPointQuery/index.vue")
      },


      {
        path: "EnrollConfirmationPointQuery",
        name: "EnrollConfirmationPointQuery",
        meta: {title: '查询定期注册确认点及用户'},
        component: () => import("@/views/basicModel/ConfirmationPointQuery/enrollIndex.vue")
      },
      {
        path: "LocaleSubModel",
        name: "LocaleSubModel",
        meta: {title: '认定确认点管理'},
        component: () => import("@/views/basicModel/LocaleSubModel/index.vue")
      },
      {
        path: "EnrollLocaleSubModel",
        name:'EnrollLocaleSubModel',
        meta:{title:'定期注册确认点管理'},
        component: () => import("@/views/basicModel/EnrollLocaleSubModel/index.vue")
      },
      {
        path: "UserSubModel",
        name: "UserSubModel",
        meta: {title: '认定确认用户管理'},
        component: () => import("@/views/basicModel/UserSubModel/index.vue")
      },
      {
        path: "UserNormal",
        name: "UserNormal",
        meta: {title: '高校用户管理'},
        component: () => import("@/views/basicModel/UserNormal/index.vue")
      },

      {
        path: "EnrollLocaleUserSubModel",
        name:'EnrollLocaleUserSubModel',
        meta:{title:'注册确认用户管理'},
        component: () => import("@/views/basicModel/EnrollLocaleUserSubModel/index.vue")
      },


      // {
      //   path: "BaseTechnicalJobSubModel",
      //   name:"BaseTechnicalJobSubModel",
      //   meta:{title:'专业技术职务管理'},
      //   component: () => import("@/views/basicModel/BaseTechnicalJobSubModel/index.vue")
      // },

      {
        path: "BaseCertTypeSubModel",
        name:"BaseCertTypeSubModel",
        meta:{title:'资格种类管理'},
        component: () => import("@/views/basicModel/BaseCertTypeSubModel/index.vue")
      },
      // {
      //   path: "BaseCollegeSubModel",
      //   name:"BaseCollegeSubModel",
      //   meta:{title:'毕业学校'},
      //   component: () => import("@/views/basicModel/BaseCollegeSubModel/index.vue")
      // },
      {
        path: "QRAudBaseOrgDocSubModel",
        name:"QRAudBaseOrgDocSubModel",
        meta:{title:'确认点导出权限备案审批'},
        component: () => import("@/views/basicModel/BaseOrgDocSubModel/audIndex.vue")
      },

      {
        path: "QRBaseOrgDocSubModel",
        name:"QRBaseOrgDocSubModel",
        meta:{title:'确认点导出权限备案'},
        component: () => import("@/views/basicModel/BaseOrgDocSubModel/qrIndex.vue")
      },

      {
        path: "BaseOrgDocSubModel",
        name:"BaseOrgDocSubModel",
        meta:{title:'机构导出权限备案'},
        component: () => import("@/views/basicModel/BaseOrgDocSubModel/index.vue")
      },

      {
        path: "BaseOrgSchoolSubModel",
        name:"BaseOrgSchoolSubModel",
        meta:{title:'定期注册中小学信息管理'},
        component: () => import("@/views/basicModel/BaseOrgSchoolSubModel/index.vue")
      },
      {
        path: "OrgNameLogSubModel",
        name: "BaseOrgHisoryLogSubModel",
        meta: {title: '机构更名日志管理'},
        component: () => import("@/views/basicModel/OrgNameLogSubModel/index.vue")
      },
      {
        path: "BaseMajorSubModel",
        name:"BaseMajorSubModel",
        meta:{title:'所学专业'},
        component: () => import("@/views/basicModel/BaseMajorSubModel/index.vue")
      },
    ]

  },
  {
    path: "/platformDocking",
    name:'platformDocking',
    component: Layout,
    meta:{title:'地方平台对接管理'},
    children:[
      {
        path: "GBSwitch",
        name: "basicRealNameVerification2",
        meta: {title: '国办接口开关管理'},
        component: () => import("@/views/SystemInfo/GBSwitch/index.vue")
      },

      {
        path: "RExceptionHandling",
        name: "RExceptionHandling",
        meta: {title: '网办异常数据回传'},
        component: () => import("@/views/SystemInfo/RExceptionHandling/index.vue")
      },


      {
        path: "Development",
        name: "basicRealNameVerification",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "Development",
        name: "basicRealNameVerification1",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "Development",
        name: "basicRealNameVerification2",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "Development",
        name: "basicRealNameVerification3",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "Development",
        name: "basicRealNameVerification4",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "Development",
        name: "basicRealNameVerification5",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "Development",
        name: "basicRealNameVerification6",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
      {
        path: "Development",
        name: "basicRealNameVerification7",
        meta: {title: '正在开发'},
        component: () => import("@/components/Development.vue")
      },
    ]
  },
  {
    path: "/register",
    name:'register',
    component: Layout,
    meta:{title:'认定管理'},
    children:[

      {
        path: "CertBatchSubModel",
        name: "CertBatchSubModel2",
        meta: {title: '认定批次管理'},
        component: () => import("@/views/kernalModel/CertBatchSubModel/index.vue")
      },
      {
        path: "ZgzxProvinceBatchSubModel",
        name: "ZgzxProvinceBatchSubModel",
        meta:{title:'审批认定计划'},
        component: () => import("@/views/kernalModel/ProvinceBatchSubModel/Zgzx/index.vue")
      },

      {
        path: "ResumeSubModel",
        name: "ResumeSubModel",
        meta: {title: '申请用户简历'},
        component: () => import("@/views/kernalModel/ResumeSubModel/index.vue")
      },
      {
        path: "RegAudSubModel",
        name: "RegAudSubModel",
        meta: {title: '注册确认审批'},
        component: () => import("@/views/kernalModel/RegAudSubModel/index.vue")
      },
      {
        path: "RegEmsSubModel",
        name: "RegEmsSubModel",
        meta: {title: '用户报名邮寄信息'},
        component: () => import("@/views/kernalModel/RegEmsSubModel/index.vue")
      },
      {
        path: "ProvinceBatchSubModel",
        name: "ProvinceBatchSubModel",
        meta: {title: '设置本省认定计划'},
        component: () => import("@/views/kernalModel/ProvinceBatchSubModel/Province/index.vue")
      },

      {
        path: "OrgBatchTimeSubModel",
        name: "OrgBatchTimeSubModel",
        meta: {title: '网报时间段'},
        component: () => import("@/views/kernalModel/OrgBatchTimeSubModel/index.vue")
      },
      {
        path: "OrgViewOrgBatchSubModel",
        name: "OrgViewOrgBatchSubModel",
        meta: {title: '查看认定计划'},
        component: () => import("@/views/kernalModel/OrgBatchSubModel/OrgView/index.vue")
      },
      {
        path: "ProvinceViewOrgBatchSubModel",
        name: "ProvinceViewOrgBatchSubModel",
        meta: {title: '省级查看认定计划'},
        component: () => import("@/views/kernalModel/OrgBatchSubModel/OrgView/ProvinceIndex.vue")
      },
      {
        path: "OrgBatchSubModel",
        name: "OrgBatchSubModel",
        meta: {title: '设置本机构认定计划'},
        component: () => import("@/views/kernalModel/OrgBatchSubModel/index.vue")
      },
      {
        path: "ChildOrgBatchSubModel",
        name: "SubordinateOrgPlan",
        meta: {title: '管理下级机构认定计划'},
        component: () => import("@/views/kernalModel/OrgBatchSubModel/ChildOrgBatchModel/index.vue")
      },
      {
        path: "RegistrationSubModel",
        name: "OrgBatchTimeSubModel",
        meta: {title: '核对网络填报数据'},
        component: () => import("@/views/kernalModel/RegistrationSubModel/index.vue")
      },

      // {
      //   path: "showPDf",
      //   name: "showPDf",sh
      //   meta: {title: '显示PDF'},
      //   component: () => import("@/views/WebPdfShow.vue")
      // },

      {
        path: "RegistrationAudSubModel",
        name: "RegistrationAudSubModel",
        meta: {title: '认定审批'},
        component: () => import("@/views/kernalModel/RegistrationAudSubModel/index.vue")
      },
      {
        path: "RegistrationOtherSubModel",
        name: "RegistrationOtherSubModel",
        meta: {title: '查看其他确认点数据'},
        component: () => import("@/views/kernalModel/RegistrationAudSubModel/OtherIndex.vue")
      },
      {
        path: "getOtherOrgRegistrations",
        name: "getOtherOrgRegistrations",
        meta: {title: '查询全国认定数据'},
        component: () => import("@/views/kernalModel/RegistrationAudSubModel/OtherOrgIndex.vue")
      },
      // {
      //   path: "QRBaseOrgDocSubModel",
      //   name:"QRBaseOrgDocSubModel",
      //   meta:{title:'确认点导出权限备案'},
      //   component: () => import("@/views/basicModel/BaseOrgDocSubModel/qrIndex.vue")
      // },
      {
        path: "SubRegistrationAudSubModel",
        name: "getSubRegistrations",
        meta: {title: '查看认定数据'},
        component: () => import("@/views/kernalModel/RegistrationAudSubModel/SubIndex.vue")
      },


      // {
      //   path: "RegistrationMonitorSubModel",
      //   name: "RegistrationMonitorSubModel",
      //   meta: {title: '监控认定数据'},
      //   component: () => import("@/views/kernalModel/RegistrationMonitorSubModel/index.vue")
      // },
      {
        path: "CompletionFinishModel",
        name: "CompletionFinishModel",
        meta: {title: '提交政务平台办结数据'},
        component: () => import("@/views/kernalModel/CompletionFinishModel/index.vue")
      },
      {
        path: "SubordinateBatchModel",
        name: "SubordinateBatchModel",
        meta: {title: '查询下属机构注册数据'},
        component: () => import("@/views/kernalModel/SubordinateBatchModel/index.vue")
      },

      {
        path: "SearchOtherBatchModel",
        name: "SearchOtherBatchModel",
        meta: {title: '查询其他机构申报数据'},
        component: () => import("@/views/kernalModel/SearchOtherBatchModel/index.vue")
      },
      {
        path: "OrgBatchEndApplySubModel",
        name: "OrgBatchEndApplySubModel",
        meta: {title: '结束认定计划'},
        component: () => import("@/views/kernalModel/ProvinceBatchSubModel/EndApplyIndex.vue")
      },
      {
        path: "OrgBatchQueryApplySubModel",
        name: "OrgBatchQueryApplySubModel",
        meta: {title: '申请提供证书验证'},
        component: () => import("@/views/kernalModel/RegistrationAudSubModel/EndIndex.vue")
      },
      {
        path: "OrgBatchEndSubModel",
        name: "OrgBatchEndSubModel",
        meta: {title: '结束认定批次'},
        component: () => import("@/views/kernalModel/ProvinceBatchSubModel/EndIndex.vue")
      },
      {
        path: "LocaleSetSubModel",
        name: "LocaleSetSubModel",
        meta: {title: '安排确认点工作'},
        component: () => import("@/views/kernalModel/LocaleSetSubModel/index.vue")
      },


      {
        path: "ProcessingData",
        name: "RegistrationEndModel",
        meta: {title: '办件数据回传统计'},
        component: () => import("@/views/kernalModel/ProcessingData/index.vue")
      },
      {
        path: "ProcessingDataReturn",
        name: "ProcessingDataReturn",
        meta: {title: '查询办结操作记录'},
        component: () => import("@/views/kernalModel/ProcessingDataReturn/index.vue")
      },
      {
        path: "GbhcDataReturn",
        name: "GbhcDataReturn",
        meta: {title: '国办回传统计'},
        component: () => import("@/views/kernalModel/GbhcDataReturn/index.vue")
      },
      {
        path: "GbhcDataReturn3",
        name: "GbhcDataReturn3",
        meta: {title: '国办推送3次失败记录报表'},
        component: () => import("@/views/kernalModel/GbhcDataReturn3/index.vue")
      },

    ]
  },
  // {
  //   path: "/SystemInfo",
  //   name:"systemManagement",
  //   meta:{title:'系统管理'},
  //   component: Layout,
  //   children: [
  //
  //     {
  //       path: "RealNameVerification",
  //       name: "realNameVerificationAndReview",
  //       meta: {title: '实名核验审核'},
  //       component: () => import("@/views/SystemInfo/RealNameVerification/index.vue")
  //     },
  //     {
  //       path: "StateOfficeSwitch",
  //       name: "StateOfficeSwitch",
  //       meta: {title: '国办接口开关管理'},
  //       component: () => import("@/views/SystemInfo/StateOfficeSwitch/index.vue")
  //     },
  //     /*{
  //       path:"SearchRecordsApproved",
  //       name:"SearchRecordsApproved",
  //       meta:{title:'查询待审批记录'},
  //       component: () => import("@/views/SystemInfo/SearchRecordsApproved/index"),
  //     }*/
  //
  //   ]
  //
  // },

  //定期注册信息管理===================================================
  {
    path: "/enrollModel",
    name:'enrollModel',
    component: Layout,
    meta:{title:'定期注册'},
    children:[
      {
        path: "RegisterSubordinateOrgPlan",
        name:'RegisterSubordinateOrgPlan',
        meta:{title:'管理下级机构定期注册计划'},
        component: () => import("@/views/enrollModel/RegisterSubordinateOrgPlan/index.vue")
      },
      {
        path: "CertBatchSubModel",
        name:'EnrollCertBatchSubModel',
        meta:{title:'设置定期注册批次'},
        component: () => import("@/views/enrollModel/CertBatchSubModel/index.vue")
      },
      {
        path: "ProvinceBatchSubModel",
        name:'EnrollSetSelfProvinceBatchSubModel',
        meta:{title:'设置本省注册计划'},
        component: () => import("@/views/enrollModel/ProvinceBatchSubModel/Province/index.vue")
      },
      {
        path: "ApproveEnrollPlan",
        name:'EnrollApproveProvinceBatchSubModel',
        meta: {title: '审批定期注册计划'},
        component: () => import("@/views/enrollModel/ApproveEnrollPlan/index.vue")
      },
      {
        path: "OrgViewOrgBatchSubModel",
        name:'EnrollOrgViewOrgBatchSubModel',
        meta:{title:'查看定期注册计划'},
        component: () => import("@/views/enrollModel/OrgBatchSubModel/OrgView/index.vue")
      },

      /*{
        path: "ProvinceOrgViewOrgBatchSubModel",
        name:'CertBatchSubModel',
        meta:{title:'省级查看注册计划'},
        component: () => import("@/views/enrollModel/OrgBatchSubModel/OrgView/ProvinceIndex.vue")
      },*/

     /* {
        path: "ProvinceBatchSubModel",
        name:'CertBatchSubModel',
        meta:{title:'管理省级注册计划'},
        component: () => import("@/views/enrollModel/ProvinceBatchSubModel/Province/index.vue")
      },*/
      {
        path: "EnrollAudSubModel",
        name:'EnrollFistCheckSubModel',
        meta:{title:'初审注册信息'},
        component: () => import("@/views/enrollModel/EnrollAudSubModel/index.vue")
      },
      {
        path: "EnrollCityAudSubModel",
        name:'EnrollAgainCheckAudSubModel',
        meta:{title:'注册审批'},
        component: () => import("@/views/enrollModel/EnrollAudSubModel/CityIndex.vue")
      },
      // {
      //   path: "EnrollProvinceAudSubModel",
      //   name:'EnrollProvinceAudSubModel',c
      //   meta:{title:'终审注册信息'},
      //   component: () => import("@/views/enrollModel/EnrollAudSubModel/ProvinceIndex.vue")
      // },

      // {
      //   path: "EnrollMonitorSubModel",
      //   name:'EnrollMonitorSubModel',
      //   meta:{title:'注册监控'},
      //   component: () => import("@/views/enrollModel/EnrollAudSubModel/MonitorIndex.vue")
      // },

     /* {
        path: "EnrollmentOtherDataModel",
        name:'EnrollmentOtherDataModel',
        meta:{title:'其他机构申报数据'},
        component: () => import("@/views/enrollModel/EnrollmentOtherDataModel/index.vue")
      },*/
      {
        path: "EnrollmentSubModel",
        name:'EnrollCheckNetWorkDataSubModel',
        meta:{title:'核对网络填报数据'},
        component: () => import("@/views/enrollModel/EnrollmentSubModel/index.vue")
      },
      {
        path: "viewConfirmationPointData",
        name:'viewConfirmationPointData',
        meta:{title:'查看其他确认点数据'},
        component: () => import("@/views/enrollModel/viewConfirmationPointData/otherIndex.vue")
      },

      {
        path: "EnrollmentSubSubModel",
        name:'EnrollmentSubSubModel',
        meta:{title:'查看注册数据'},
        component: () => import("@/views/enrollModel/EnrollmentSubModel/subIndex.vue")
      },
      {
        path: "EnrollmentOtherSubModel",
        name:'EnrollmentOtherSubModel',
        meta:{title:'查询全国注册数据'},
        component: () => import("@/views/enrollModel/EnrollmentSubModel/otherIndex.vue")
      },
      /*{
        path: "OrgBatchTimeSubModel",
        name:'CertBatchSubModel',
        meta:{title:'网报时间段'},
        component: () => import("@/views/enrollModel/OrgBatchTimeSubModel/index.vue")
      },*/
      {
        path: "OrgBatchSubModel",
        name:'EnrollSelfOrgBatchSubModel',
        meta:{title:'设置本机构注册计划'},
        component: () => import("@/views/enrollModel/OrgBatchSubModel/index.vue")
      },
      {
        path: "OrgBatchProvinceSubModel",
        name:'EnrollProvinceAndDownOrgSubModel',
        meta:{title:'设置省级机构注册计划'},
        component: () => import("@/views/enrollModel/OrgBatchProvinceSubModel/index.vue")
      },
      {
        path: "OrgBatchCitySubModel",
        name:'EnrollOrgAndDownOrgInfoSubModel',
        meta:{title:'查看注册计划'},
        component: () => import("@/views/enrollModel/OrgBatchCitySubModel/index.vue")
      },

      // {
      //   path: "LocaleSubModel",
      //   name:'EnrollLocaleSubModel',
      //   meta:{title:'确认点管理'},
      //   component: () => import("@/views/enrollModel/LocaleSubModel/index.vue")
      // },

      {
        path: "LocaleSetSubModel",
        name:'EnrollLocaleSetSubModel',
        meta:{title:'安排确认点工作'},
        component: () => import("@/views/enrollModel/LocaleSetSubModel/index.vue")
      },


      {
        path: "EnrollOrgBatchEndApplySubModel",
        name:'EnrollOrgBatchEndApplySubModel',
        meta:{title:'结束注册计划'},
        component: () => import("@/views/enrollModel/OrgBatchSubModel/EndApplyIndex.vue")
      },

      {
        path: "EnrollOrgBatchEndSubModel",
        name:'EnrollOrgBatchEndSubModel',
        meta:{title:'结束注册批次'},
        component: () => import("@/views/enrollModel/OrgBatchSubModel/EndIndex.vue")
      },
     /* {
        path: "ViewRegistrationData",
        name:'ViewRegistrationData',
        meta:{title:'结束定期注册批次'},
        component: () => import("@/views/enrollModel/ViewRegistrationData/index.vue")
      },*/
      // {
      //   path: "UserSubModel",
      //   name:'EnrollLocaleUserSubModel',
      //   meta:{title:'确认用户管理'},
      //   component: () => import("@/views/enrollModel/UserSubModel/index.vue")
      // },

    ]
  },



  {
    path: "/limitModel",
    name: "limitModelMenu",
    component: Layout,
    meta: {title: '限制库管理'},
    children: [

      {
        path: "LimitationInfoSubModel",
        name: "LimitationInfoSubModel",
        meta: {title: '限制库管理'},
        component: () => import("@/views/limitModel/LimitationInfoSubModel/index.vue")
      },
      {
        path: "LimitationInfoFuHeSubModel",
        name:"LimitationInfoFuHeSubModel",
        meta:{title:'限制库审批'},
        component: () => import("@/views/limitModel/LimitationInfoFuHeSubModel/index.vue")
      },

      {
        path: "PushRecordQuery",
        name: "PushRecordQuery",
        meta: {title: '限制库推送记录查询'},
        component: () => import("@/views/limitModel/LimitationInfoSubPushRecordQuery/index.vue")
      },
      {
        path: "AllRestrictedLibraryData",
        name: "AllRestrictedLibraryData",
        meta: {title: '查询全国限制库数据'},
        component: () => import("@/views/limitModel/LimitationInfoSubModelAll/index.vue")
      },

      {
        path: "LimitationInfoSubOtherModel",
        name:"LimitationInfoSubOtherModel",
        meta:{title:'其他机构限制库查询',requireAuth: true},
        component: () => import("@/views/limitModel/LimitationInfoSubOtherModel/index.vue")
      },
      {
        path: "LimitationSubModel",
        name: "LimitationSubModel",
        meta: {title: '限制库发布初审'},
        component: () => import("@/views/limitModel/LimitationSubModel/index.vue")
      },
      {
        path: "WfWorkflowAuditSubModel",
        name:"WfWorkflowAuditSubModel",
        meta:{title:'限制库发布审批'},
        component: () => import("@/views/limitModel/WfWorkflowAuditSubModel/index.vue")
      },
      // {
      //   path: "WfWorkflowMainSubModel",
      //   name:"WfWorkflowMainSubModel",
      //   meta:{title:'流程主表管理'},
      //   component: () => import("@/views/limitModel/WfWorkflowMainSubModel/index.vue")
      // },
      // {
      //   path: "WfWorkflowNodeSubModel",
      //   name:"WfWorkflowNodeSubModel",
      //   meta:{title:'流程节点管理'},
      //   component: () => import("@/views/limitModel/WfWorkflowNodeSubModel/index.vue")
      // }
    ]
  },

  //证书信息管理
  {
    path: "/historyDataManage",
    name:'historyDataManage',
    component: Layout,
    meta:{title:'证书信息管理',requireAuth: true},
    children:[
      {
        path: "CertSubModel",
        name:'CertSubModel',
        meta:{title:'教师资格证书管理',requireAuth: true},
        component: () => import("@/views/certModel/CertSubModel/index.vue")
      },
      {
        path: "CertAdditionSubModel",
        name:'CertAdditionSubModel',
        meta:{title:'证书补发换发管理',requireAuth: true},
        component: () => import("@/views/certModel/CertAdditionSubModel/index.vue")
      },
      {
        path: "CertificateOfRegistration",
        name:'CertificateOfRegistration',
        meta:{title:'证书变更审批管理',requireAuth: true},
        component: () => import("@/views/certModel/CertOfRegistration/index.vue")
      },
      {
        path: "CertChangeSubModel",
        name:'CertChangeSubModel',
        meta:{title:'变更申请信息',requireAuth: true},
        component: () => import("@/views/certModel/CertChangeSubModel/index.vue")
      },
      {
        path: "HistoryValidSubModel",
        name:'queryHistoryValid',
        meta:{title:'查看认定历史数据',requireAuth: true},
        component: () => import("@/views/certModel/HistoryValidSubModel/index.vue")
      },
      {
        path: "HistoryTempSubModel",
        name:'queryHistoryTemp',
        meta:{title:'认定非正式历史数据查询',requireAuth: true},
        component: () => import("@/views/certModel/HistoryTempSubModel/index.vue")
      },
      {
        path: "HistoryValidTempSubModel",
        name:'queryHistoryValidTemp',
        meta:{title:'查看广西2012年前认定数据查询',requireAuth: true},
        component: () => import("@/views/certModel/HistoryValidTempSubModel/index.vue")
      },
      {
        path: "EnrollHistoryTempSubModel",
        name:'queryEnrollHistoryTemp',
        meta:{title:'定期注册非正式历史数据查询',requireAuth: true},
        component: () => import("@/views/certModel/EnrollHistoryTempSubModel/index.vue")
      },


      {
        path: "nationalHistoricalData",
        name:'queryALLHistoryValid',
        meta:{title:'查询全国认定历史数据',requireAuth: true},
        component: () => import("@/views/certModel/HistoryValidSubModel/nationIndex.vue")
      },
      {
        path: "registeredCountryHistoricalData",
        name:'registeredCountryHistoricalData',
        meta:{title:'查询全国定期注册历史数据',requireAuth: true},
        component: () => import("@/views/certModel/CountryHistoricalData/nationIndex.vue")
      },

      {
        path: "EnrollHistorySubModel",
        name:'EnrollHistorySubModel',
        meta:{title:'定期注册历史数据管理',requireAuth: true},
        component: () => import("@/views/certModel/EnrollHistorySubModel/index.vue")
      },
      {
        path: "EnrollHistoryChangeAuditSubModel",
        name:'EnrollHistoryChangeAuditSubModel',
        meta:{title:'注册历史数据变更审批',requireAuth: true},
        component: () => import("@/views/certModel/EnrollHistoryChangeAuditSubModel/index.vue")
      },



      // {
      //   path: "certificateChangeLog",
      //   name:'certificateChangeLog',
      //   meta:{title:'证书信息变更日志',requireAuth: true},
      //   component: () => import("@/views/certModel/ChangeSubModel/index.vue")
      // },

      {
        path: "HistoricalDataLog",
        name:'HistoricalDataLog',
        meta:{title:'定期注册历史数据结论变更日志',requireAuth: true},
        component: () => import("@/views/certModel/ChangeSubModel/index.vue")
      },


    ]
  },

  {
    path: "/ecertModel",
    name:'ecertModel',
    component: Layout,
    meta:{title:'电子证照管理',requireAuth: true},
    children:[

      {
        path: "ecertOrgStamp",
        name:'ecertOrgStamp',
        meta:{title:'机构电子印章管理',requireAuth: true},
        component: () => import("@/views/ecertModel/EcertOrgStampSubModel/index.vue")
      },
      {
        path: "ecert",
        name:'ecert',
        meta:{title:'本机构证书及电子证照管理',requireAuth: true},
        component: () => import("@/views/ecertModel/CertSubModel/index.vue")
      },
      {
        path: "ecertCert",
        name:'ecertCert',
        meta:{title:'电子证照痕迹信息',requireAuth: true},
        component: () => import("@/views/ecertModel/EcertCertSubModel/index.vue")
      },
      {
        path: "ecertChange",
        name:'ecertChange',
        meta:{title:'电子证照变更信息管理',requireAuth: true},
        component: () => import("@/views/ecertModel/EcertChangeSubModel/index.vue")
      },
      {
        path: "ecertTask",
        name:'ecertTask',
        meta:{title:'电子证照任务信息管理',requireAuth: true},
        component: () => import("@/views/ecertModel/EcertTaskSubModel/index.vue")
      }
    ]
  },

  {
    path: "/applicantModel",
    name:'applicantModel',
    component: Layout,
    meta:{title:'申请人信息管理'},
    children:[
      {
        path: "RealNameVerification",
        name: "basicRealNameVerification",
        meta: {title: '实名核验审核'},
        component: () => import("@/views/applicantModel/RealNameVerification/index.vue")
      },

      {
        path: "SsouserSubModel",
        name:'querySsouser',
        meta:{title:'申请人基本信息'},
        component: () => import("@/views/applicantModel/SsouserSubModel/index.vue")
      },
      {
        path: "ScoreSubModel",
        name:'ScoreSubModel',
        meta:{title:'国考信息'},
        component: () => import("@/views/applicantModel/ScoreSubModel/index.vue")
      },
      {
        path: "NormalPreServiceTeacherSubModel",
        name:'NormalPreServiceTeacherSubModel',
        meta:{title:'免试师范生信息'},
        component: () => import("@/views/applicantModel/NormalPreServiceTeacherSubModel/index.vue")
      },
      {
        path: "SsouserPthCertSubModel",
        name:'SsouserPthCertSubModel',
        meta:{title:'普通话证书信息'},
        component: () => import("@/views/applicantModel/SsouserPthCertSubModel/index.vue")
      },
      {
        path: "OtherCertificatesModel",
        name:'OtherCertificatesModel',
        meta:{title:'其他证书信息'},
        component: () => import("@/views/applicantModel/OtherCertificatesModel/index.vue")
      },
      {
        path: "SsouserStudentSubModel",
        name:'SsouserStudentSubModel',
        meta:{title:'学籍信息管理'},
        component: () => import("@/views/applicantModel/SsouserStudentSubModel/index.vue")
      },
      {
        path: "SsouserCollegeCertSubModel",
        name:'SsouserCollegeCertSubModel',
        meta:{title:'学历信息管理'},
        component: () => import("@/views/applicantModel/SsouserCollegeCertSubModel/index.vue")
      },
      {
        path: "SsouserDegreeCertSubModel",
        name:'SsouserDegreeCertSubModel',
        meta:{title:'学位信息管理'},
        component: () => import("@/views/applicantModel/SsouserDegreeCertSubModel/index.vue")
      },
      {
        path: "ssouserAccessqueryModel",
        name:'ssouserAccessqueryModel',
        meta:{title:'性侵准入查询信息'},
        component: () => import("@/views/applicantModel/SsouserAccessquerySubModel/index.vue")
      },
    ]
  },




  {
    path: "/monitor",
    name:'monitor',
    component: Layout,
    meta:{title:'统计报表'},
    children:[

      {
        path: "MonAlertSubModel",
        name:'MonAlertSubModel',
        meta:{title:'告警监测'},
        component: () => import("@/views/monitorModel/MonAlertSubModel/index.vue")
      },
      {
        path: "MonReportDesign",
        name:'MonReportDesign',
        meta:{title:'报表模型设计'},
        component: () => import("@/views/monitorModel/MonReportDesign/index.vue")
      },
      {
        path: "systemMonitor",
        name:'systemMonitor',
        meta:{title:'系统监测报表'},
        component: () => import("@/views/monitorModel/SystemMonitorSubModel/index.vue")
      },
      {
        path: "regMonitor",
        name:'regMonitor',
        meta:{title:'认定报表'},
        component: () => import("@/views/monitorModel/SystemMonitorSubModel/index.vue")
      },
      {
        path: "enrollMonitor",
        name:'enrollMonitor',
        meta:{title:'定期注册报表'},
        component: () => import("@/views/monitorModel/SystemMonitorSubModel/index.vue")
      },
      // {
      //   path: "historyMonitor",
      //   name:'historyMonitor',
      //   meta:{title:'历史数据报表'},
      //   component: () => import("@/views/monitorModel/SystemMonitorSubModel/index.vue")
      // },

    ]
  },
  {
    path: "/eduDocModel",
    name: "eduDocModel",
    meta: {title: '资料下载'},
    component: () => import("@/views/basicModel/EduDocSubModel/index.vue")
  },

]



const router = new Router({
  mode: "history",
  base: '/tqc/',
  // base: process.env.BASE_URL,
  routes
});




const reSetPermissionList = (to,menu) => {
  return new Promise((resolve, reject) => {
    if (to.path !== '/Login' && store.state.Myrouters.length== 0) {
      store.dispatch('GenerateRoutes',menu).then(() => {
        resolve('permCode')
      })
        .catch(error => {
          resolve('permCode')
        })
    } else {
      resolve()
    }
  })
}


router.beforeEach((to, from, next) => {


  NProgress.start()
  if (sessionStorage.getItem("unInfo")) {
    if(to.path=='/Login'){
      next({ path: '/' })
      NProgress.done()
    }
    else{
      if(store.state.mymenudata.length==0){
        let userInfo2= JSON.parse(sessionStorage.getItem("unInfo"))
        if(userInfo2.user.superuser==1){
          reSetPermissionList(to,[]).then(data => {
            data === 'permCode' ? next({ path: to.path, query: to.query }) : next()
          })

        }

        else{
          reSetPermissionList(to,userInfo2.privilege.menu).then(data => {
            data === 'permCode' ? next({ path: to.path, replace:true }) : next()
          })
          // store.dispatch("GenerateRoutes",userInfo.privilege.menu)
        }
        store.dispatch("setTabPermissions",userInfo2.user.orgType);
      }
    }
    next()

  } else {
    if (to.path != '/Login' && to.path != '/findPassword') {
      next(`/Login?redirect=${to.fullPath}`)
      NProgress.done()
    } else {
      next()
    }
  }
  // NProgress.start()
  //   if (sessionStorage.getItem("unInfo")) {
  //     next()
  //   } else {
  //     if (to.path !== '/Login') {
  //       next(`/Login?redirect=${to.fullPath}`)
  //       NProgress.done()
  //     } else {
  //       next()
  //     }
  //   }

});

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

router.afterEach(() => {


  NProgress.done()
})


// router.beforeEach((to, from, next) => {
//   // if (to.matched.some(record => record.meta.requireAuth)) {
//   NProgress.start()
//   if (sessionStorage.getItem("unInfo")) {
//     if(to.path=='/Login'){
//       next({ path: '/' })
//       NProgress.done()
//     }
//     // else{
//     //
//     //   if(store.state.mymenudata.length==0){
//     //     let userInfo2= JSON.parse(sessionStorage.getItem("unInfo"))
//     //     if(userInfo2.user.superuser==1){
//     //       reSetPermissionList(to,[]).then(data => {
//     //         data === 'permCode' ? next({ path: to.path, query: to.query }) : next()
//     //       })
//     //     }
//     //     else{
//     //       reSetPermissionList(to,userInfo2.privilege.menu).then(data => {
//     //         data === 'permCode' ? next({ path: to.path, replace:true }) : next()
//     //       })
//     //       // store.dispatch("GenerateRoutes",userInfo.privilege.menu)
//     //     }
//     //   }
//     //
//     // }
//
//     next()
//
//   } else {
//     if (to.path !== '/Login') {
//       next(`/Login?redirect=${to.fullPath}`)
//       NProgress.done()
//     } else {
//       next()
//     }
//
//
//
//   }
//
// });
//
// router.afterEach(() => {
//   NProgress.done()
// })


export default router



// WEBPACK FOOTER //
// ./src/router/index.js